// Whether two sets of report settings would run the same report.
//
// Comparing the JSON text is not enough: register, cashier, tender and account settings are
// { id, label }, and the label differs between the dropdown ("Register 2 (full) - Main Campus
// Store") and the server ("Register 2") for the same choice; and changing a setting and
// changing it back reorders the object's keys. Either made unchanged settings look changed.
export function sameSettings(first, second) {
    return canonical(first) === canonical(second);
}

// The settings as sorted [key, value] pairs, entities reduced to their id, unset values dropped.
function canonical(settings) {
    const values = settings || {};

    return JSON.stringify(
        Object.keys(values)
            .filter(key => values[key] !== null && values[key] !== undefined && values[key] !== '')
            .sort()
            .map(key => [key, idOf(values[key])]));
}

function idOf(value) {
    return value && typeof value === 'object' && 'id' in value ? value.id : value;
}
